import React from "react";
import PageHeader from "../components/PageHeader";

export default function AdministrationAndFinance() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Pages", link: "/pages" },
    { label: "Administration & Finance", active: true },
  ];

  return (
    <div>
      {/* Page Header */}
      <PageHeader title="Administration & Finance" breadcrumbs={breadcrumbs} />

     

      {/* Highlight Section */}
      <div className="container-fluid bg-light py-5 mt-5 border-top">
        <div className="container wow fadeInUp" data-wow-delay="0.2s">
          <div className="text-center mb-5">
            <h6 className="section-title text-primary fw-bold">
              Financial Framework
            </h6>
            <h2 className="display-6 fw-semibold">
              Administration and Finance (BSCPCR, Govt. of India)
            </h2>
          </div>

          <div className="row g-4">
            {/* Central Govt */}
            <div className="col-md-6">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100">
                <h5 className="text-primary mb-3">Grants by Central Government</h5>
                <p className="text-secondary mb-0">
                 The Central Government shall, after due appropriation made by Parliament by law on this behalf, pay to the commission by way of grants such sums of money as the Central Government may think fit for being utilized for the purpose of protection of child rights.
                <br />
                The commission may spend such sums of money as it thinks fit for performing the functions under the Commissions for Protection of Child Rights (CPCR) Act 2005, and such sums shall be treated as expenditure payable out of the grants received from the Central Government.
                </p>
              </div>
            </div>

            {/* State Govt */}
            <div className="col-md-6">
              <div className="p-4 bg-primary text-white rounded-4 shadow-sm h-100">
                <h5 className="mb-3">Grants by State Governments</h5>
                <p className="mb-0 text-white-75">
                  The State Government shall, after due appropriation made by the legislature by law on this behalf, pay to the State Commission by way of grants such sums of the money as the State Government may think fit for being utilised for the purpose Commissions for Protection of Child Rights (CPCR) Act 2005.
                 <br />
                 The state commission may spend such sums of money as it thinks fit for performing the functions mentioned under the Commissions for Protection of Child Rights (CPCR) Act 2005, and such sums shall be treated as expenditure payable out of the grants received from the State government.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
